export default "__VITE_ASSET__7310924e__"